export default "__VITE_ASSET__Gfnvs_jg__"